// Role within a team: a member is either a regular member or the team lead.
export enum TeamRole {
  MEMBER = 'member',
  LEAD = 'lead',
}

// Role on company-member level: a regular member or a (hidden) support account.
export enum MemberRole {
  MEMBER = 'member',
  SUPPORT = 'support',
}
